import type { JSX } from 'react';

/**
 * @graph-stack styling-pattern-watch
 * @graph-domain Styling
 * @graph-business スタイリングコンソールのトップバー（ロゴ・パンくず・ユーザー情報）
 * @graph-connects none
 */
export function Topbar(props: { user: string }): JSX.Element {
  return (
    <header className="topbar">
      <div className="topbar-left">
        <div className="logo">S</div>
        <div>
          <div className="breadcrumb">
            スタイリングコンソール / 在庫モニタリング / <strong>選定可能型数ウォッチ</strong>
          </div>
        </div>
      </div>
      <div className="topbar-right">
        <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{props.user}</span>
      </div>
    </header>
  );
}
